import { FC } from 'react';

const TermsAndConditionsPage: FC = () => {
  return (
    <div className="flex flex-col gap-6 max-w-full mx-auto w-[1280px] px-4 py-10">
      <h1 className="font-bold text-3xl">Conditions of Website Use</h1>

      <section className="flex flex-col gap-4">
        <p>
          Access to and use of any information on this website is conditional on your acceptance of these conditions of
          website use ("Conditions") without modification. Please read them carefully. We recommend you print out and
          keep a copy of them for your future reference. If you do not wish to accept any part of them, you must not use
          our website.
        </p>
        <p>
          In these Conditions, "you" and "your" means any and all persons using this website. "We", "us" and "our" means
          DMV Trading Ltd as operator of the Past Papers Plus website (www.pastpapersplus.com).
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">General Conditions</h2>
        <p>
          As a condition of your use of this website, you warrant to us that you will not use it or any material or
          information on it for any purpose that is unlawful or prohibited by these Conditions or otherwise. We reserve
          the right in our sole, absolute and unfettered discretion at any time to restrict or prohibit access to this
          website for any user for any reason, and especially to restrict or prohibit access for users who demonstrate
          patterns of abuse or improper use of this website or who breach these Conditions.
        </p>
        <p>
          You warrant that you are at least 14 years old and have the legal authority to use this website in accordance
          with these Conditions. You agree to be financially responsible (or have permission from a parent or guardian)
          for all charges, fees and other sums of whatever nature which arise out of your use of this website.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Intellectual Property Rights</h2>
        <p>
          This website is for your personal and non-commercial use. No part of this website may be reproduced in any form
          without our prior consent, other than temporarily in the course of using our SaaS (Software as a Service) to
          provide students and teachers with a personalised interface to Chat GPT and a personalised AI Search Chatbot.
          You may not modify, copy, distribute, transmit, display, reproduce, publish, license, create derivative works
          from, transfer, sell or in any other way use any material, information, products or services contained or
          featured on this website. The copyright in our personalised interface to ChatGPT belongs to DMV Trading Ltd.
          All other Intellectual Property Rights are reserved.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Governing Law</h2>
        <p>
          We are an English registered Company. Our business and the services we offer are governed exclusively by the
          applicable laws of England and Wales except where otherwise stated. No warranties and/or representations of any
          kind, express or implied, are given by us as to the compliance of the information shown on this website, the
          services offered by or on behalf of us or by or on behalf of any Suppliers, any information relating to such
          services and/or our business and/or Arrangements in any respect with any laws of any other country. Such laws
          do not, in any event, affect or apply to the same.
        </p>
        <p>
          Access to this website is conditional on your agreement that all information contained in it and all matters
          which arise between you and us will be governed by English law. Access is further conditional on your agreement
          that any dispute or matter which arises between you and us will be dealt with by the Courts of England and
          Wales only to the exclusion of the Courts of any other country.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Linking to Our Website</h2>
        <p>You must not link (including deep linking) to our website without our prior written agreement.</p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Disclaimer of Warranties and Limitation of Liability</h2>
        <p>
          No warranties, promises and/or representations of any kind, express or implied, are given as to the accuracy or
          completeness of any of the material or information contained on this website or as to the nature, standard,
          suitability or otherwise of any services offered by us or on our behalf or by or on behalf of any Suppliers or
          of any Arrangements. We shall not be liable for any loss or damage or other sum or claim of any nature
          whatsoever (direct, indirect, consequential or other) which arises, directly or indirectly, in connection with
          this website including, for the avoidance of doubt and not by way of limitation, any use of any information or
          material contained in this website or any inability to access or use (or delay in doing so) this website.
        </p>
        <p>All exclusions of liability apply only to the extent permitted by law.</p>
        <p>
          If any exclusion(s) or limitation(s) contained in these Conditions is found, in whole or part, to be unlawful,
          void or for any other reason unenforceable for any purpose(s), that exclusion(s) or limitation(s) or the
          part(s) in question shall be deemed severable and omitted from these Conditions for that purpose / those
          purposes. Such omission shall not affect the validity, effectiveness or enforceability of the other provisions
          of these Conditions.
        </p>
        <p>
          Without prejudice to the foregoing provisions, we are entitled to the benefit of any applicable exclusions
          and/or limitations of liability permitted by the laws of any country found to be applicable to the information
          shown on this website and/or any services offered by us or on our behalf.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Accuracy of Information</h2>
        <p>
          The information contained on this website may contain technical inaccuracies and typographical and other
          errors. The information on these pages may be updated from time to time and may at times be out of date. We
          accept no responsibility for keeping the information on these pages up to date or liability for failure to do
          so. You must ensure you check all details of all Arrangements (including the price) with the provider of those
          Arrangements.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Third Party Websites</h2>
        <p>
          This website contains links to other websites. Except where they belong to us, such other websites are not
          under our control or maintained by us. We are not responsible for the content of such websites. We provide
          these links for your convenience only but do not monitor or endorse the material on them. We cannot accept any
          liability whatsoever and howsoever arising in relation to any such other websites (including, for the avoidance
          of doubt and not by way of limitation, any inability to access or delay in accessing any such other website) or
          in relation to any material or information appearing on them or which you may otherwise come across after
          leaving our site by way of a hypertext link or any other means.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Computer Viruses</h2>
        <p>
          We make no warranty that this website (or any websites that are linked to this website) is free from technical
          errors, computer viruses or any other malicious or impairing computer programs. It is your responsibility to
          ensure you carry out sufficient checks (including virus checks) to satisfy your particular requirements.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Changes to These Conditions</h2>
        <p>
          We may alter these Conditions at any time. If we do so, all subsequent use of our website will be governed by
          the newer version. You must check these Conditions regularly.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Prohibited Content</h2>
        <p>
          The transmission of threatening, defamatory, pornographic, political or racist material or any material that is
          otherwise unlawful is expressly prohibited. We reserve the right in our absolute discretion to remove any and
          all material (including messages and statements of opinion) from this website which we feel are in breach of
          this condition or which we otherwise feel is inappropriate.
        </p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Nature of Content</h2>
        <p>Nothing on this website constitutes an offer on our part for the Arrangements referred to or accessed on or via it.</p>
      </section>

      <section className="flex flex-col gap-4">
        <h2 className="font-bold text-2xl">Privacy</h2>
        <p>
          For details on how we use the personal information you give us please see our{' '}
          <a href="/privacy-policy" className="link link-primary">
            Privacy Policy
          </a>
          .
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditionsPage;
